import { asyncLoadRouter } from '@router/helper'

const firmwares = [
  {
    path: 'firmwares',
    component: asyncLoadRouter('manager/Firmwares'),
    meta: {
      authorize: ['admin', 'manager', 'technician'],
      breadcrumb: (i18n) => [
        {
          text: i18n.t('activerecord.models.firmware.other'),
          to: { name: 'manager-firmwares' },
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'manager-firmwares',
        component: asyncLoadRouter('manager/firmwares/List'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.list') }] },
      },
      {
        path: 'new',
        name: 'manager-firmwares-new',
        component: asyncLoadRouter('manager/firmwares/New'),
        meta: {
          breadcrumb: (i18n) => [
            {
              text: i18n.t('shared.actions.new'),
              to: { name: 'manager-firmwares-new' },
            },
          ],
        },
        props: { action: 'create' },
      },
      {
        path: ':firmware_id([A-Za-z\\d]{22})',
        name: 'manager-firmwares-show',
        component: asyncLoadRouter('manager/firmwares/Show'),
        redirect: (to) => {
          return {
            name: 'manager-firmwares-edit',
            params: { firmware_id: to.params.firmware_id },
          }
        },
        meta: {
          breadcrumb: (i18n, params) => [
            {
              text: `ID ${params.firmware_id}`,
              to: {
                name: 'manager-firmwares-edit',
                params: { firmware_id: params.firmware_id },
              },
            },
          ],
        },
        children: [
          {
            path: 'edit',
            name: 'manager-firmwares-edit',
            component: asyncLoadRouter('manager/firmwares/Form'),
            meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
            props: { action: 'update' },
          },
        ],
      },
    ],
  },
]

export default firmwares
